import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SupportTicket, SupportTicketCreate, SupportTicketFilter } from '../data/supportTicket';

export function createSupportTicketService(client: AxiosInstance) {
  return createCrudService<SupportTicket, SupportTicketCreate, SupportTicketFilter>(
    client,
    '/crm/SupportTicket',
    'id',
  );
}

export type SupportTicketService = CrudService<SupportTicket, SupportTicketCreate, SupportTicketFilter>;
